import React from 'react';

const resources = [
  { id: 1, title: 'Cost Transparency Tool', icon: '\u{1F4B2}' },
  { id: 2, title: 'Provider Manual', icon: '\u{1F4D6}' },
  { id: 3, title: 'Clinical Guidelines', icon: '\u{1FA7A}' },
  { id: 4, title: 'Fee Schedule', icon: '\u{1F4CA}' },
];

const ContactResourcesPageInner = () => {
  return (
    <div className="main-content">
      <div className="page-header">
        <div>
          <h1>Contact Us & Resources</h1>
          <p>Get in touch with Sendero Health Plans or access helpful provider resources</p>
        </div>
      </div>

      <div
        className="contact-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 28,
        }}
      >
        {/* Left Column - Contact Us */}
        <div className="card" style={{ padding: 32 }}>
          <h3
            style={{
              margin: '0 0 6px 0',
              fontSize: 20,
              fontWeight: 700,
              color: '#134E4A',
            }}
          >
            Contact Us
          </h3>
          <div
            style={{
              width: 40,
              height: 3,
              background: 'linear-gradient(135deg, #0F766E, #0D9488)',
              borderRadius: 2,
              marginBottom: 16,
            }}
          />
          <p
            style={{
              margin: '0 0 24px 0',
              fontSize: 14,
              color: '#6B7280',
              lineHeight: 1.6,
            }}
          >
            Get in touch with us for support, claims, or provider inquiries.
          </p>

          {/* New Claims / Appeals */}
          <div style={{ marginBottom: 24 }}>
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#0D9488',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                marginBottom: 8,
              }}
            >
              New Claims / Appeals
            </div>
            <div style={{ fontSize: 14, color: '#1A1D21', lineHeight: 1.7 }}>
                          {/*<div style={{ fontWeight: 600 }}>Central Health</div>*/}
                          <div>P. O. Box 17337,</div>
                          <div>Austin, TX 78760</div>
            </div>
          </div>

          {/* Provider Customer Service */}
          <div style={{ marginBottom: 24 }}>
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#0D9488',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                marginBottom: 8,
              }}
            >
              Provider Customer Service
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                marginBottom: 6,
              }}
            >
              <span style={{ fontSize: 16 }}>{'\u{1F4DE}'}</span>
              <span style={{ fontSize: 15, fontWeight: 600, color: '#1A1D21' }}>
                              512-978-8669<br></br>844-316-2004

              </span>
            </div>
          </div>

          {/* Email */}
          <div style={{ marginBottom: 24 }}>
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#0D9488',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                marginBottom: 8,
              }}
            >
              Email
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                marginBottom: 6,
              }}
            >
              <span style={{ fontSize: 16 }}>{'\u{2709}\uFE0F'}</span>
              <a
                              href="mailto:chproviderservices@centralhealth.net"
                style={{ fontSize: 14, fontWeight: 500, color: '#0D9488' }}
              >
                              chproviderservices@centralhealth.net
              </a>
            </div>
          </div>

          {/* Hours */}
          <div>
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#0D9488',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                marginBottom: 8,
              }}
            >
              Hours of Operation
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <span style={{ fontSize: 16 }}>{'\u{1F552}'}</span>
              <span style={{ fontSize: 14, color: '#1A1D21' }}>
                Mon - Fri, 8:00 AM - 5:00 PM CT
              </span>
            </div>
          </div>
        </div>

        {/* Right Column - Resources */}
        <div
          className="card"
          style={{
            background: 'linear-gradient(135deg, #134E4A 0%, #0F766E 100%)',
            border: 'none',
            padding: 32,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* Decorative circles */}
          <div
            style={{
              position: 'absolute',
              top: -30,
              right: -30,
              width: 120,
              height: 120,
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.04)',
            }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: -20,
              left: -20,
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.03)',
            }}
          />

          <div style={{ position: 'relative', zIndex: 1 }}>
            <h3
              style={{
                margin: '0 0 6px 0',
                fontSize: 20,
                fontWeight: 700,
                color: '#FFFFFF',
              }}
            >
              Resources
            </h3>
            <div
              style={{
                width: 40,
                height: 3,
                background: 'rgba(45,212,191,0.6)',
                borderRadius: 2,
                marginBottom: 16,
              }}
            />
            <p
              style={{
                margin: '0 0 24px 0',
                fontSize: 14,
                color: 'rgba(255,255,255,0.7)',
                lineHeight: 1.6,
              }}
            >
              Find helpful tools and links to make managing your plan easier.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {resources.map((resource) => (
                <div
                  key={resource.id}
                  onClick={() =>
                    alert(`Opening ${resource.title}... (demo only)`)
                  }
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: 14,
                    padding: '14px 18px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.16)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <span style={{ fontSize: 20 }}>{resource.icon}</span>
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: '#FFFFFF',
                      flex: 1,
                    }}
                  >
                    {resource.title}
                  </span>
                  <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 18 }}>
                    {'\u203A'}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactResourcesPageInner;
